'use client';

import classNames from 'classnames';
import {
    Facebook as FacebookIcon,
    Linkedin as LinkedinIcon,
    Twitter as TwitterIcon,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import styles from './SocialShareBlock.module.scss';

const { NEXT_PUBLIC_WEBSITE_URL } = process.env;

interface Props {
    className?: string;
    iconClassName?: string;
    roundIcons?: boolean;
    url?: string;
    text?: string;
    title?: string;
}

export function SocialShareBlock({
    className,
    iconClassName,
    roundIcons,
    title,
    url,
    text,
}: Props) {
    const [shareLink, setShareLink] = useState(NEXT_PUBLIC_WEBSITE_URL);

    const classes = classNames(iconClassName, styles.button, {
        [styles.rounded]: roundIcons,
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setShareLink(window.location.href);
        }
    }, []);

    return (
        <div className={classNames(className, styles.wrapper)}>
            <FacebookShareButton
                title={text ?? title}
                className={classNames(classes, styles.facebook)}
                url={url ?? shareLink}
            >
                <FacebookIcon className={styles.icon} />
            </FacebookShareButton>
            <TwitterShareButton
                title={text ?? title}
                className={classNames(classes, styles.twitter)}
                url={url ?? shareLink}
            >
                <TwitterIcon className={styles.icon} />
            </TwitterShareButton>
            <LinkedinShareButton
                title={text ?? title}
                className={classNames(classes, styles.linkedin)}
                url={url ?? shareLink}
            >
                <LinkedinIcon className={styles.icon} />
            </LinkedinShareButton>
        </div>
    );
}
